import url from './config.js';
import axios from 'axios';
import { weixinFg } from '@/public/public'//微信授权
import store from "./src/store";
let instance = axios.create({
  baseURL: url.require,
  method: 'post',
  headers: { 'Content-Type': 'multipart/form-data' },
  timeout: 60000000,
});
instance.interceptors.request.use(function (config) {
  // store.commit('isLoadingFg', true)
  // 在发送请求之前做些什么
  return config;
}, function (error) {
  // 对请求错误做些什么
  return Promise.reject(error);
});

instance.interceptors.response.use(function (response) {
  console.log(response.data.content)
  if (response.config.data.indexOf('Base.wxLogin') && response.data.content && response.data.content.token && response.data.status != 600) {
    localStorage.setItem('token', response.data.content.token)
    localStorage.setItem('isToken', response.data.content.token ? true : false)
    localStorage.setItem('member_id', response.data.content.id)
    localStorage.setItem('userInfo', JSON.stringify(response.data.content))
  }
  // 对响应数据做点什么
  return response;
}, function (error) {
  // 对响应错误做点什么
  return Promise.reject(error);
});
// 添加请求拦截器
let http = function (url, params, file) {
  // if (params.isClick) {
  // this.isBtnShow = true
  // }
  let data
  if (file) {
    data = params
  } else {
    data = {
      "content": {
        "base": {
          "time": '121212121212',
          "source": "4",
          "equipment": "苹果7",
          "token": localStorage.getItem('token') || '',
          "version": "v1.0"
        },
        "data": {
          "method": url,
          ...params
        }
      },
      "lock": "",
      "time": "121212121212",
      "app_key": "7ab4bcfc-adf6-11e9-af3f-0800274e100a"
    }
  }
  let request = 'post'
  return new Promise((resolu, rejec) => {
    instance[request]('', data).then((res) => {
      // store.commit('isLoadingFg', false)
      // if (res.data.status == 200) {
      //   console.log(res.data.status)
      //   this.$root.isBtnShow = false
      // } else {
      //   this.$root.isBtnShow = false
      // }
      if (res.data.status == 100 || res.data.status == 1034) {//100 状态失效 1034 
        localStorage.setItem('isToken', false)
        store.commit('LoginFailure', true)
        console.log(res.data.status, store.state.LoginFailure)
        return false
      };
      resolu(res.data)
    }).catch((err) => {
      rejec(err)
    })
  })
}

export default http